import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=c46cf2bc&scoped=true"
import script from "./batch.vue?vue&type=script&lang=js"
export * from "./batch.vue?vue&type=script&lang=js"
import style0 from "./batch.vue?vue&type=style&index=0&id=c46cf2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46cf2bc",
  null
  
)

export default component.exports